export default __webpack_public_path__ + "static/media/carton.6bd3d47f.png";